import React from 'react';
import './PdfDownloader.css';

const ImageDownloader = ({ imageSrc, hoverName, fileUrl, fileName }) => {
  return (
    <a 
      href={fileUrl} 
      download={fileName} 
      className="download-container"
    >
      <img 
        src={imageSrc} 
        alt={hoverName} 
        className="download-image" 
      />
      
      <div className="overlay">
        <div className="text">{hoverName}</div>
      </div>
    </a>
  );
};

export default ImageDownloader;